import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ApolloProvider } from '@apollo/client';
import apolloClient from "./api/apollo-client";
// import { ReactQueryDevtools } from 'react-query/devtools';
import { QueryClient, QueryClientProvider } from 'react-query';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: true,
    },
  },
});

const CustomQueryClientProvider = ({ children }:any) => {
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
};


ReactDOM.render(
  <React.StrictMode>
    <ApolloProvider client={apolloClient}>
      <CustomQueryClientProvider>
      {/*<ReactQueryDevtools initialIsOpen={false} />*/}
      <App />
      </CustomQueryClientProvider>
    </ApolloProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
